var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 43,
    viewBox: "0 0 46 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4498 34.9426L21.9665 35.7988L21.4498 34.9426L11.0913 41.1946C10.334 41.6517 9.39972 40.9727 9.60068 40.1113L12.3496 28.3278C12.6026 27.2433 12.2341 26.1079 11.3924 25.3788L2.23756 17.4479C1.56896 16.8687 1.92637 15.7705 2.8078 15.6957L14.8578 14.6734C15.9665 14.5793 16.9321 13.8793 17.3664 12.8548L22.0793 1.73497C22.4239 0.92194 23.5761 0.92194 23.9207 1.73497L28.6336 12.8548C29.0679 13.8793 30.0335 14.5793 31.1422 14.6734L43.1922 15.6957C44.0736 15.7705 44.431 16.8687 43.7624 17.4479L34.6076 25.3788C33.7659 26.1079 33.3974 27.2433 33.6504 28.3278L36.3993 40.1113C36.6003 40.9727 35.6661 41.6517 34.9087 41.1946L24.5502 34.9426C23.5968 34.3672 22.4032 34.3672 21.4498 34.9426Z",
    stroke: "#E0E0E0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetUnselected);
export default __webpack_public_path__ + "static/media/TargetUnselected.876d6e284f3aa9ae10692ddcb584d79c.svg";
export { ForwardRef as ReactComponent };